import { routerReducer } from 'react-router-redux';
import { ApiReducer as api } from 'reactifi-local';
import topicReducer from './topicReducer';

export default {
  topics: topicReducer,
  routing: routerReducer,
  api,
};
